import { AdaptivePracticeContext, AppContext } from "../../../context/context";
import { PlayFrame } from "../frame/PlayFrame";
import { ContentFactoryImpl, Content } from '@mathbuddy/adaptive-practice-engine';
import { getTimeSpent } from '../../../utils/utils';
import { Component } from "react";
import { StatusCodes } from "http-status-codes";
import apis from "../../../apis/api";
import { adaptivePracticeActions } from "../../../reduxStore";
import { connect } from "react-redux";
import { IQuestionTxn, LiveSession } from "./liveSession";
import { applyTheme, resolveTheme } from '../theme';



class RiseSessionForTeacher extends Component<any, any> {
    static contextType = AppContext;
    context!: { windowHeight: string, windowWidth: string, messageForParent: any, navigateTo: any };
    constructor(props: any) {
        super(props)
        this.state = {
            // Optional `theme` prop from the parent; falls back to this screen's own
            // default. Resolved once - the theme cannot change between questions.
            theme: resolveTheme(props.theme),
            currentUser: this.props.currentUser,
            langObj: { number_lang: '', lang: '' },
            contentFactoryObj: new ContentFactoryImpl(),
            contentObj: new Content(),
            liveSession: new LiveSession(
                this.props.sessionInfo.sessionId,
                this.props.sessionInfo.sessionNo,
                this.props.sessionInfo.batchId,
                this.props.currentUser.id
            ),
            sessionInfo: this.props.sessionInfo,
            questionsList: [] as { id: string, skill_id: string, safeZone: boolean, }[],
            isNewSession: true,
            isLoader: false,
            isCoinAnimation: false,
            coins: 0,
            streaks: 0,
            currentQuestion: {} as { id: string, skill_id: string, safeZone: boolean, reviewObj: any },
            currentQuestionPosition: 0,
            totalQuestions: 0,
            uniqQuestionIds: [],
            startTime: 0,
            totalCorrectAttemptedQuestion: 0,
            totalAttemptedQuestions: 0,
            totalAttemptedCount: 0,
            accuracy: 0,
            notificationMessage: '',
            response: { component: [] },
            currentQuestionTxn: {},
            isShowAdaptivePopup: false,
            isCloseFromClick: false,
        }
    }

    isAssessmentSession = () => { return this.state.sessionInfo.qualifier === "ASSESSMENT"; }

    componentDidMount = () => {
        // Paint the frame ONCE per screen - 21 custom properties, not a per-question cost.
        applyTheme(this.state.theme);
        this.getLatestStateOnMount();
    }

    getLatestStateOnMount = async () => {
        await this.sendLastAttemptedIfAny(); // if window is reloaded and last attempted questions is there send it to DB.
        this.setState({ isLoader: true });
        let streaksAndCoins = await this.getStreaksAndCoins();
        let currentUser = this.props.currentUser;
        let country_code = currentUser.country_code;

        let langObj = { number_lang: 'en', lang: this.props.lang + '_' + country_code.toLowerCase() };
        const RZ_ID = this.state.sessionInfo.adaptiveId;
        const questionsList = this.isAssessmentSession() ?
            await this.state.contentObj.getAssessmentQuestionsById(RZ_ID) :
            await this.state.contentObj.getReasoningZoneQuestionsById(RZ_ID);
        this.setState({
            ...streaksAndCoins,
            langObj,
            isLoader: false,
            questionsList,
            totalQuestions: questionsList.length,
        }, () => {
            this.loadSessionContent();
        })
    }

    getStreaksAndCoins = async () => {
        let returnObj = { coins: 0, streaks: 0 };

        let currentUser = this.state.currentUser;
        let dashboardSummary = await apis._getLastUserSummary(currentUser.id);
        if (dashboardSummary.status === StatusCodes.OK && dashboardSummary.data.result.length > 0) {
            let lastSummary = dashboardSummary.data.result[0];

            returnObj.coins = lastSummary.total_coins
            returnObj.streaks = lastSummary.current_streak;
        }

        return returnObj;
    }

    loadSessionContent = async () => {
        try {
            this.sendLastAttemptedIfAny();// if Teacher reload the questions or click next or prev and last attempted is not send to db incase of wong attempt in first attempt 
            this.setState({ isLoader: true, response: { component: [] } });

            let currentQuestionPosition = this.state.currentQuestionPosition;
            let currentQuestion: {
                id: string, skill_id: string,
                safeZone: boolean, txn: IQuestionTxn, reviewObj?: any
            } = this.state.questionsList[currentQuestionPosition];

            if (this.state.sessionInfo.isLiveMode && !this.isAssessmentSession()) {
                currentQuestion.safeZone = false; //always false in live class
                const txns = await this.state.liveSession.getQuestionTxn([{ qId: currentQuestion.id, loId: currentQuestion.skill_id }]);
                currentQuestion.txn = (txns.length > 0) ? txns[0] : {};
            }

            const review_obj = this.isAssessmentSession() ? { ...currentQuestion.reviewObj } : {};

            let langObj = this.state.langObj;

            await this.state.contentObj.loadSkillBySkillId(currentQuestion.skill_id, this.state.theme, langObj.lang)

            let response = await this.state.contentFactoryObj.displayQuestion(this.state.contentObj,
                this.state.contentObj.createContentTemplateObject(currentQuestion.id, 'REACT_WEB'), langObj, JSON.parse(JSON.stringify(review_obj)));
            console.log("response_skills", response);

            // Update state
            this.setState({
                startTime: new Date(),
                currentQuestion,
                response,
            }, () => {
                //console.log(this.state);
                this.setState({ isLoader: false });
            })

        } catch (error) {
            this.setState({ isLoader: false })
        }
    }

    getNotificationMessage = (streak: number) => {
        let message = ''
        if (streak > 0 && (streak % 2) === 0) {
            message = (streak < 10) ? `${streak} in a row!` :
                (streak < 20) ? `You are on a roll! ${streak} in a row` :
                    (streak <= 22) ? `Bravo! ${streak} in a row` :
                        `Way to go. ${streak} in a row`;
        }
        return message;
    }

    saveQuestionResponse = async (answerObj: { givenAnswer: any, actualAnswer: any, isCorrectAns: Boolean }, clickCount: number) => {
        const currentQuestion: { id: string, skill_id: string, safeZone: boolean } = this.state.currentQuestion;
        const isSafeZone = currentQuestion.safeZone || false;
        const isStreakFreeze = this.state.sessionInfo.isLiveMode;
        const isCorrectAns = answerObj.isCorrectAns;

        let coins = (isCorrectAns) ? (this.state.coins + 1) : this.state.coins;
        let streaks = (isStreakFreeze) ? this.state.streaks :// no gain and no loss
            (isCorrectAns) ? (this.state.streaks + 1) ://gain on correct answer
                (isSafeZone) ? this.state.streaks ://no loss on wrong answer for safeZone
                    0;// reset 

        let time_spent = getTimeSpent(this.state.startTime);
        let notificationMessage = isCorrectAns ? this.getNotificationMessage(streaks) : '';
        let totalCorrectAttemptedQuestion = (isCorrectAns) ? this.state.totalCorrectAttemptedQuestion + 1 : this.state.totalCorrectAttemptedQuestion;
        let totalAttemptedQuestions = (isSafeZone || isCorrectAns || clickCount > 1) ? this.state.totalAttemptedQuestions + 1
            : this.state.totalAttemptedQuestions;

        let totalAttemptedCount = this.state.totalAttemptedCount + 1;
        let accuracy = Math.round((totalCorrectAttemptedQuestion * 100) / totalAttemptedCount) || 0;

        this.setState({
            isCoinAnimation: isCorrectAns, coins, streaks, notificationMessage, totalCorrectAttemptedQuestion,
            totalAttemptedQuestions, accuracy, totalAttemptedCount, isCloseFromClick: false
        },
            () => {
                setTimeout(() => {
                    this.setState({ isCoinAnimation: false, notificationMessage: '' })
                }, 1700)
            });

        let lastAttemptedData = this.props.adaptivePracticeReducer.sessionLastAttemptedQuestion;
        let currentAnswer = [{ "isCorrect": answerObj.isCorrectAns, "answer": answerObj.givenAnswer }];

        let data = {
            "questions": [{
                "isNewSession": this.state.isNewSession,
                "user_id": this.state.currentUser.id,
                "session_id": this.state.sessionInfo.sessionId,
                "lo_id": currentQuestion.skill_id,
                "question_id": currentQuestion.id,
                "review_obj": this.state.response.reviewObj,
                "number_lang": this.state.langObj.number_lang,
                "lang": this.state.langObj.lang,
                "answers": [...lastAttemptedData.questions[0].answers, ...currentAnswer],
                "isCorrect": answerObj.isCorrectAns,
                "isStreakFreeze": isStreakFreeze,
                "isSafeZone": isSafeZone,
                "time_spent": lastAttemptedData.questions[0].time_spent + time_spent,
                "blooms": this.state.response.blooms,
            }],
            qualifier: this.state.sessionInfo.qualifier === 'ASSESSMENT' ? 'ASSESSMENT' : "SESSION",
            sessionNumber: this.state.sessionInfo.sessionNo,
            sessionQuestionIds: this.state.questionsList.map((q: { id: string, skill_id: string }) => `${q.id}_${q.skill_id}`)
        }

        if (!isSafeZone && clickCount === 1 && !answerObj.isCorrectAns) {
            this.props.setAPLastAttempted(data);
            return    // return from here if answer is incorrect in the first attempt and not a safe zone question.
        }

        // console.log(data);
        let uniqQuestionIds: string[] = this.state.uniqQuestionIds;
        let filterUniqQuestionId = uniqQuestionIds.filter((qId: string) => qId.toString() === currentQuestion.id.toString());
        if (filterUniqQuestionId.length === 0)
            uniqQuestionIds.push(currentQuestion.id);

        this.setState({ isNewSession: false, uniqQuestionIds },
            async () => {
                let response = await this.saveQuestionResponseToDB(data);
                // console.log(response);
                if (response?.status === StatusCodes.OK) {
                    // if (isCorrectAns)
                    //     this.loadSessionContent();
                }
            });
    }

    saveQuestionResponseToDB = async (data: any) => {
        // console.log(data);
        let response = await apis._saveQuestionResponseForAdaptiveSession(data);
        if (response?.status === StatusCodes.OK) {
            this.props.setAPDefaultLastAttempted();// set default last attempted question with empty answer array.
        }
        return response;
    }

    getPopUpInfo = () => {
        let accuracy = this.state.accuracy;
        const isLiveMode = this.state.sessionInfo.isLiveMode;
        const compledQuestionsInLiveMode = this.state.sessionInfo.compledQuestions || 0;
        const completedQuestionCount = isLiveMode ? compledQuestionsInLiveMode : this.state.uniqQuestionIds.length;

        let completedStatus = Math.round((completedQuestionCount / this.state.totalQuestions) * 100);

        let heading =
            (completedStatus <= 20) ? "You are just getting started! Are you sure?" :
                (completedStatus <= 40) ? "There are more questions to go! Are you sure?" :
                    (completedStatus <= 80) ? "You are doing well! Are you sure?" :
                        (completedStatus < 100) ? "Just a few more questions to go! Are you sure?" :
                            (isLiveMode) ? "Great job! Reasoning Zone completed." :
                                (accuracy === 0) ? 'You need to practice a lot' :
                                    (accuracy < 50) ? 'Can do better with practice' :
                                        (accuracy < 80) ? 'Keep practicing. You can do better' :
                                            (accuracy < 90) ? 'You did well. Try to score 100%' :
                                                'Way to go! You were perfect!';

        let showAnimation = (completedStatus === 100) ? true : false;

        return {
            streaks: isLiveMode ? 0 : this.state.streaks,
            accuracy: accuracy,
            totalAttemptedQuestions: this.state.sessionInfo.isLiveMode ? this.state.sessionInfo.compledQuestions || 0 : this.state.totalAttemptedQuestions,
            completedStatusPercentage: completedStatus,
            isShowStartPopup: false,// no need to show start popup for teachers
            isSafeZone: false,// no need to show safeZone popup for teachers
            isCloseFromClick: this.state.isCloseFromClick,
            heading, showAnimation
        }
    }

    setShowAdaptivePopup = async (isCloseFromClick: Boolean = false) => {
        this.setState({ isLoader: true })
        let isShowAdaptivePopup = !this.state.isShowAdaptivePopup
        if (isShowAdaptivePopup && this.state.sessionInfo.isLiveMode)
            await this.checkAllQuestionsStatusOnClose();

        this.setState({ isCloseFromClick, isShowAdaptivePopup, isLoader: false });
    }

    checkAllQuestionsStatusOnClose = async () => {
        let allQuestionTxns = await this.state.liveSession.getAllQuestionTxnKeys();
        console.log(allQuestionTxns);
        const compledQuestions: { [key: string]: boolean } = {};
        allQuestionTxns.forEach((qTxn: IQuestionTxn) => {
            if (qTxn.status === 'COMPLETED') {
                compledQuestions[`${qTxn.q_id}_${qTxn.lo_id}`] = true;
            }
        });
        const isSessionCompleted = this.state.questionsList.every((q: { id: string, skill_id: string }) => compledQuestions.hasOwnProperty(`${q.id}_${q.skill_id}`));
        this.setState({
            sessionInfo: {
                ...this.state.sessionInfo,
                isSessionCompleted,
                compledQuestions: Object.keys(compledQuestions).length
            }
        });
    }

    sendLastAttemptedIfAny = async () => {
        let lastAttemptedData = this.props.adaptivePracticeReducer.lastAttemptedQuestion;
        if (lastAttemptedData.questions[0].answers.length) {
            this.setState({ isLoader: true });
            await this.saveQuestionResponseToDB(lastAttemptedData);
            this.setState({ isLoader: false });
        }
    }

    onClose = async () => {
        await this.sendLastAttemptedIfAny();
        console.log("Close Session", this.state.sessionInfo);
        this.context.messageForParent('close', this.state.sessionInfo);
    }

    onQuestionShare = () => {
        let currentQuestion = this.state.currentQuestion;
        let cqTxn = currentQuestion.txn;

        console.log("Share");
        console.log(currentQuestion);

        cqTxn.status = 'STARTED';
        cqTxn.start_time = new Date();
        cqTxn.end_time = null;
        cqTxn.completed_students = 0;
        cqTxn.score = 0;
        cqTxn.reviewObj = JSON.stringify(this.state.response.reviewObj);

        currentQuestion.txn = cqTxn;

        //update state and live session txn in redis
        this.setState({ currentQuestion });
        this.state.liveSession.setQuestionTxn(cqTxn);

        //notify parent to share with students
        const question_id = `${cqTxn.q_id}_${cqTxn.lo_id}`;
        this.context.messageForParent('share', { questionTxn: cqTxn, question_id });
    }

    onQuestionComplete = () => {
        console.log("questionComplete");
        let currentQuestion = this.state.currentQuestion;
        let cqTxn = currentQuestion.txn;

        cqTxn.status = "COMPLETED";
        cqTxn.end_time = new Date();

        currentQuestion.txn = cqTxn;

        //update state and live session txn in redis
        this.setState({ currentQuestion });
        this.state.liveSession.setQuestionTxn(cqTxn);

        //notify parent to stop share with students
        const question_id = `${cqTxn.q_id}_${cqTxn.lo_id}`;
        this.context.messageForParent('questionComplete', { questionTxn: cqTxn, question_id });
    }

    render() {
        console.log(this.state.sessionInfo.isLiveMode);
        return (
            <AdaptivePracticeContext.Provider value={{
                notificationMessage: this.state.notificationMessage,
                coins: this.state.coins,
                streaks: this.state.sessionInfo.isLiveMode ? undefined : this.state.streaks,
                isSafeZone: this.state.currentQuestion.safeZone,
                meter: { percentage: 0, level: '' },
                isLoader: this.state.isLoader,
                isCoinAnimation: this.state.isCoinAnimation,
                isShowStartPopup: false,
                isShowAdaptivePopup: this.state.isShowAdaptivePopup,
                isCloseFromClick: this.state.isCloseFromClick,
                engineObj: this.state.response,
                options: {
                    isShowReload: !this.isAssessmentSession(),
                    session: !this.isAssessmentSession() ? {
                        isLive: this.state.sessionInfo.isLiveMode,
                        status: this.state.currentQuestion.txn?.status || '',
                        onShare: this.onQuestionShare,
                        onComplete: this.onQuestionComplete
                    } : undefined,
                    questionSummaryHeader: {
                        current: this.state.currentQuestionPosition,
                        total: this.state.totalQuestions,
                        setCurrentPos: (pos: number) => {
                            this.setState({ currentQuestionPosition: pos }, () => {
                                this.loadSessionContent();
                            })
                        }
                    }
                },
                loadContent: this.loadSessionContent,
                saveQuestionResponse: this.saveQuestionResponse,
                getPopUpInfo: this.getPopUpInfo,
                setShowAdaptivePopup: this.setShowAdaptivePopup,
                onclose: this.onClose
            }}>
                <PlayFrame></PlayFrame>
            </AdaptivePracticeContext.Provider>
        )
    }
}

function mapStateToProps(state: any) { return state; }

let setAPLastAttempted = adaptivePracticeActions.setAPSessionLastAttempted;
let setAPDefaultLastAttempted = adaptivePracticeActions.setAPSessionDefaultLastAttempted;


const mapDispatchToProps = { setAPLastAttempted, setAPDefaultLastAttempted };

export default connect(mapStateToProps, mapDispatchToProps)(RiseSessionForTeacher);